export const formatName = (val) => {
  if (!val) return '';
  return val.replace(/[^a-zA-Z\s]/g, '').replace(/\b\w/g, c => c.toUpperCase());
};

export const formatCategoryName = (val) => {
  if (!val) return '';
  // Allow alphanumeric and spaces, auto-capitalize
  return val.replace(/[^a-zA-Z0-9\s]/g, '').replace(/\b\w/g, c => c.toUpperCase());
};

export const formatPhone = (val) => {
  if (!val) return '';
  // Strictly 10 digits for Indian mobile numbers
  return val.replace(/[^\d]/g, '').slice(0, 10);
};

export const formatSKU = (val) => {
  if (!val) return '';
  // Uppercase alphanumeric, no spaces
  return val.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
};

export const formatNumber = (val) => {
  if (!val) return '';
  // Positive numbers, allow decimal point
  let num = val.replace(/[^0-9.]/g, '');
  // Prevent multiple decimals
  const parts = num.split('.');
  if (parts.length > 2) {
    num = parts[0] + '.' + parts.slice(1).join('');
  }
  return num;
};

export const formatInteger = (val) => {
  if (!val) return '';
  // Positive integers only
  return val.replace(/[^0-9]/g, '');
};

export const formatGST = (val) => {
  if (!val) return '';
  // Uppercase alphanumeric, max 15 (max length typically handled by input, but we enforce formatting)
  return val.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().slice(0, 15);
};

export const formatPAN = (val) => {
  if (!val) return '';
  // Uppercase alphanumeric, max 10
  return val.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().slice(0, 10);
};

export const formatPincode = (val) => {
  if (!val) return '';
  // Indian pincode is exactly 6 digits
  return val.replace(/[^\d]/g, '').slice(0, 6);
};
